import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	IconButton,
	List,
	ListItem,
	Paper,
	Stack,
	Typography,
} from '@mui/material';
import * as React from 'react';
import { ExternalServiceIntegration } from '../../api/integrations';
import {
	INTEGRATION_HEADER_LABEL,
	INTEGRATION_URL_LABEL,
} from '../../data/constants';
import { convertHeadersToArray } from '../../utils';

interface Props {
	integration: ExternalServiceIntegration;
	onEdit: (integration: ExternalServiceIntegration) => void;
	onDelete: (integration: ExternalServiceIntegration) => void;
}

export default function IntegrationCard({
	integration,
	onEdit,
	onDelete,
}: Props) {
	const headers = integration.headers
		? convertHeadersToArray(integration.headers)
		: [];

	const [headersExpanded, setHeadersExpanded] = React.useState(false);
	return (
		<Paper
			sx={{
				borderRadius: 2,
				mt: 2,
				width: '100%',
			}}
		>
			<List>
				<ListItem divider={true}>
					<Box
						display='flex'
						alignItems='center'
						justifyContent='space-between'
						sx={{ width: '100%' }}
					>
						<Typography variant='bodySemiBold' sx={{ wordBreak: 'break-all' }}>
							{integration.name}
						</Typography>
						<Box>
							<IconButton
								size='small'
								color='primary'
								sx={{ mr: 0.5 }}
								onClick={() => {
									onEdit(integration);
								}}
							>
								<EditIcon fontSize='small' />
							</IconButton>
							<IconButton
								size='small'
								color='primary'
								onClick={() => {
									onDelete(integration);
								}}
							>
								<DeleteIcon fontSize='small' />
							</IconButton>
						</Box>
					</Box>
				</ListItem>
				<ListItem>
					<Box sx={{ width: '100%' }} mt={1}>
						<Typography variant='bodySemiBold'>
							{INTEGRATION_URL_LABEL()}
						</Typography>
					</Box>
				</ListItem>
				<ListItem sx={{ pt: 0 }}>
					<Box sx={{ width: '100%' }} mt={0}>
						<Typography
							variant='body2'
							color='body2'
							sx={{ wordBreak: 'break-all' }}
						>
							{integration.url}
						</Typography>
					</Box>
				</ListItem>
				{headers.length > 0 && (
					<Accordion
						disableGutters
						expanded={headersExpanded}
						onChange={(e, expanded) => setHeadersExpanded(expanded)}
						sx={{ boxShadow: 'none' }}
					>
						<AccordionSummary expandIcon={<ExpandMoreIcon />}>
							<Typography variant='bodySemiBold'>
								{INTEGRATION_HEADER_LABEL(true)}
							</Typography>
						</AccordionSummary>
						<AccordionDetails>
							{headers.map((header, index) => (
								<Stack key={index} mb={2}>
									<Typography
										variant='bodySemiBold'
										color='body1'
										sx={{ mb: 1 }}
									>
										{header.headerName}
									</Typography>
									<Typography
										variant='body1'
										color='body2'
										sx={{ wordWrap: 'break-word' }}
									>
										{header.value}
									</Typography>
								</Stack>
							))}
						</AccordionDetails>
					</Accordion>
				)}
			</List>
		</Paper>
	);
}
